<willow-layout [address]="offer.subjectProperty?.address">
  <perch-icons-letter-dotted role="icon"></perch-icons-letter-dotted>
  <h3 role="header">Offer not found</h3>
  <p class="text-body">
    This home sale offer is no longer valid.
    If you haven’t received a new offer, contact our Customer Experience Team at
    <a href="mailto:support@orchard.com">support@orchard.com</a>.
  </p>
</willow-layout>
